import { Offer } from "../interfaces";

export const offerRemappingFromResult = (data: any) => {
  let finalObj: Offer = {
    id: data?.id,
    client: data.client.name,
    client_id: data.client_id,
    short_description: data.short_description,
    issue_date: data?.issue_date,
    close_date: data?.close_date,
    approved_date: data?.approved_date,
    location: data.location,
    offer_name: data.offer_name,
    budget: data.budget,
    budget_shared: data.budget_shared,
    category: data.category,
    composite_shared: data.composite_shared,
    expiration_date: data.expiration_date,
    link: data.link,
    lookbook_shared: data.lookbook_shared,
    password: data.password,
    requested_models: data.requested_models,
    imageSrc: data?.imageSrc,
    long_description: data.long_description,
    status: data.status,
    models_proposed_list: data?.models_proposed_list,
    models_accepted_list: data?.models_accepted_list,
  };
  return finalObj;
};

export const dataRemappingForShareApi = (obj: any) => {
  let finalObj: any = {};
  if (obj.password_selected === null) {
    obj.password = "";
  }
  if (obj.expiration_date_selected === null) {
    obj.expiration_date = "";
  }
  const entries = Object.entries(obj);
  entries.forEach((entry) => {
    if (
      entry[0] === "password_selected" ||
      entry[0] === "expiration_date_selected"
    ) {
    } else if (
      (typeof entry[1] === typeof "String" && entry[1] != "") ||
      (typeof entry[1] === typeof false && entry[1] != false)
    ) {
      finalObj[entry[0]] = entry[1];
    }
  });
  /* 
  console.log(Object.entries(finalObj).length); */
  if (Object.entries(finalObj).length === 0) {
    finalObj = null;
  }
  /* console.log(finalObj); */
  return finalObj;
};

/*
RESULTS FROM API UPDATE:

budget: null
budget_shared: null
category: null
client_id: 18
composite_shared: null
created_at: "2022-12-01T23:25:52.000000Z"
description: null
expiration_date: 1
id: 55
imageSrc: "https://cdn.tua.blacknachos.com/images/EIB7eMZw788pRQ7.png"
issue_date: "2022-12-12 00:00:00"
link: "www.AAAAA.it"
location: "Milan"
long_description: null
lookbook_shared: 0
models_accepted_list: Array [ {…} ]
models_proposed_list: Array [ {…}, {…} ]
offer_name: "Sfilata"
offer_status: null
password: 0
requested_models: 3
short_description: null
status: "pending"
updated_at: "2022-12-01T23:31:24.000000Z"
*/
